export const STAGES = [
  { key: "new", label: "New", color: "#94a3b8" },
  { key: "researching", label: "Researching", color: "#a78bfa" },
  { key: "contacted", label: "Contacted", color: "#60a5fa" },
  { key: "interested", label: "Interested", color: "#22d3ee" },
  { key: "qualified", label: "Qualified", color: "#34d399" },
  { key: "quoted", label: "Quoted", color: "#fbbf24" },
  { key: "won", label: "Won", color: "#10b981" },
  { key: "lost", label: "Lost", color: "#f87171" },
];
export const stageOf = (k) => STAGES.find((s) => s.key === k) || STAGES[0];

export const OUTCOMES = [
  { key: "interested", label: "Interested", color: "#22d3ee" },
  { key: "call_back", label: "Call Back", color: "#60a5fa" },
  { key: "send_info", label: "Send Information", color: "#a78bfa" },
  { key: "appointment_booked", label: "Appointment Booked", color: "#10b981" },
  { key: "not_interested", label: "Not Interested", color: "#f87171" },
  { key: "gatekeeper", label: "Gatekeeper", color: "#fbbf24" },
  { key: "no_answer", label: "No Answer", color: "#94a3b8" },
  { key: "wrong_number", label: "Wrong Number", color: "#fb923c" },
  { key: "existing_contract", label: "Existing Contract", color: "#e879f9" },
  { key: "do_not_contact", label: "Do Not Contact", color: "#ef4444" },
];
export const outcomeLabel = (k) => OUTCOMES.find((o) => o.key === k)?.label || k;

export const WARMTH_COLORS = { "Very cold": "#64748b", Cold: "#60a5fa", Potential: "#fbbf24", Warm: "#fb923c", Hot: "#ef4444", "Do not contact": "#ef4444", "Insufficient engagement": "#94a3b8" };

export const PHONE_QUALITY = {
  invalid_format: { label: "Invalid format", color: "#f87171" },
  valid_format: { label: "Valid UK format", color: "#fbbf24" },
  potentially_assigned: { label: "Potentially assigned", color: "#60a5fa" },
};
export const PHONE_FLAGS = [
  { key: "verified_working", label: "Verified working" },
  { key: "reception_only", label: "Reception only" },
  { key: "wrong_number", label: "Wrong number" },
  { key: "disconnected", label: "Disconnected" },
  { key: "not_company", label: "No longer this company" },
];
export const CONTACT_ROLES = [
  { key: "decision_maker", label: "Decision maker" },
  { key: "influencer", label: "Influencer" },
  { key: "gatekeeper", label: "Gatekeeper" },
  { key: "user", label: "User" },
  { key: "other", label: "Other" },
];

export const fmtDur = (s) => (s >= 60 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${s || 0}s`);
